export const CHECKOUT_URL = "https://self-en.impultienda.ar/checkout/";

export const MOCKUP_IMAGE =
  "https://cdn.magicpatterns.com/uploads/d2cvQQpEZjh4muwoMjaH7A/MOCKUP_SELF-EN.png";

export const AUTHOR_IMAGE =
  "https://cdn.magicpatterns.com/uploads/dxG84kfGSnkiubyejSt4Ss/VALERIA_MONTES_-_BIOMECANICA.png";

export const insideItems = [
  "6 Specialized Clinical Volumes",
  "5 Exclusive Professional Bonuses",
  "Visual Biomechanics Reference Guides",
  "Clinical Decision Pathways",
  "Treatment Planning Checklists",
  "Archwire Selection Reference Tables",
  "Case Assessment & Troubleshooting Worksheets",
];

export const valueStack = [
  { label: "SELF-LIGATING ORTHODONTICS BLUEPRINT™", detail: "6 Specialized Clinical Volumes", value: "$97" },
  { label: "BONUS #1", detail: "Self-Ligating Clinical Decision Atlas™", value: "$37" },
  { label: "BONUS #2", detail: "Archwire Selection Reference Guide™", value: "$27" },
  { label: "BONUS #3", detail: "Self-Ligating Biomechanics Visual Casebook™", value: "$29" },
  { label: "BONUS #4", detail: "Orthodontic Troubleshooting Workbook™", value: "$27" },
  { label: "BONUS #5", detail: "One-Page Self-Ligating Treatment Planning Template™", value: "$27" },
];

export const offerIncludes = [
  "All 6 Specialized Volumes",
  "All 5 Professional Bonuses",
  "Digital Educational Resources",
  "Immediate Digital Access",
  "Lifetime Access",
  "No Monthly Subscription",
];

export const guaranteeItems = [
  "All six specialized volumes",
  "The visual biomechanics explanations",
  "The archwire reference materials",
  "The educational case scenarios",
  "The planning worksheets",
  "The five professional bonuses",
];

export const recentBuyers = [
  { name: "Dr. Sofía M.", country: "Mexico" },
  { name: "Dr. Mateo R.", country: "Argentina" },
  { name: "Dr. Valentina G.", country: "Colombia" },
  { name: "Dr. Diego A.", country: "Chile" },
  { name: "Dr. Camila P.", country: "Peru" },
  { name: "Dr. Andrés L.", country: "Spain" },
  { name: "Dr. Lucía F.", country: "Uruguay" },
  { name: "Dr. Javier C.", country: "Ecuador" },
  { name: "Dr. Isabella V.", country: "Venezuela" },
  { name: "Dr. Carlos B.", country: "Costa Rica" },
  { name: "Dr. Gabriela N.", country: "Dominican Republic" },
  { name: "Dr. Martín S.", country: "Paraguay" },
  { name: "Dr. Daniela H.", country: "Guatemala" },
  { name: "Dr. Fernando Q.", country: "Bolivia" },
  { name: "Dr. Mariana T.", country: "Panama" },
  { name: "Dr. Alejandro D.", country: "Puerto Rico" },
];
